<template>
	<div class="right-fixed-panel">
		<div class="fixed-content">
			<div class="action-buttons">
				<div class="app-container" @mouseenter="appIcon = '/icon/common/app-white.png'"
					@mouseleave="appIcon = '/icon/common/app.png'">
					<div class="action-item app-item">
						<div class="action-icon">
							<img :src="appIcon">
						</div>
						<span class="action-text">{{ $t('app') }}</span>
					</div>
					<div class="app-tooltip">
						<div class="tooltip-qr">
							<img src="/icon/common/qrcode.svg" class="tooltip-qr-image">
							<span class="tooltip-qr-text">{{ $t('scanToDownload') }}</span>
						</div>
						<div class="tooltip-buttons">
							<button class="tooltip-button app-store">
								<img src="/icon/common/download-ios.svg">
								<span class="tooltip-btn-text">
									<span class="download-text">{{ $t('downloadAppleStore') }}</span>
								</span>
							</button>
							<button class="tooltip-button google-play">
								<img src="/icon/common/download-android.svg">
								<span class="tooltip-btn-text">
									<span class="download-text">{{ $t('downloadGooglePlay') }}</span>
								</span>
							</button>
						</div>
					</div>
				</div>

				<div class="discord-container" @mouseenter="discordIcon = '/icon/common/discord-white.png'"
					@mouseleave="discordIcon = '/icon/common/discord.png'">
					<div class="action-item discord-item">
						<div class="action-icon">
							<img :src="discordIcon">
						</div>
						<span class="action-text">{{ $t('discord') }}</span>
					</div>
					<div class="discord-tooltip">
						<div class="discord-tooltip-top">
							{{ $t('discordMeetFriends') }}
						</div>
						<div class="discord-tooltip-bottom">
							<div class="discord-tooltip-qr">
								<img src="/icon/common/qrcode.svg" class="discord-tooltip-qr-image">
								<span class="discord-tooltip-qr-text">{{ $t('discordScanToFollow') }}</span>
							</div>
							<div class="discord-tooltip-buttons">
								<button class="discord-tooltip-button app-store">
									<img src="/icon/common/discord-white.png">
									<span class="discord-tooltip-btn-text">
										<span class="discord-download-text">{{ $t('discordJoinPlatform') }}</span>
									</span>
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="action-item" @click="handleAction('relay')"
					@mouseenter="forwardIcon = '/icon/common/forward-white.png'"
					@mouseleave="forwardIcon = '/icon/common/forward.png'">
					<div class="action-icon">
						<img :src="forwardIcon">
					</div>
					<span class="action-text">{{ $t('relay') }}</span>
				</div>

				<div class="action-item" @click="handleEnquiry"
					@mouseenter="enquiryIcon = '/icon/common/enquiry-white.png'"
					@mouseleave="enquiryIcon = '/icon/common/enquiry.png'">
					<div class="action-icon">
						<img :src="enquiryIcon">
					</div>
					<span class="action-text">{{ $t('enquiry') }}</span>
				</div>

				<div class="action-item" @click="handleComplaint" v-if="showComplaint"
					@mouseenter="complaintIcon = '/icon/common/complaint-white.png'"
					@mouseleave="complaintIcon = '/icon/common/complaint.png'">
					<div class="action-icon">
						<img :src="complaintIcon">
					</div>
					<span class="action-text">{{ $t('complaint') }}</span>
				</div>

				<div class="action-item" @click="scrollToTop">
					<div class="action-icon">
						<i class="el-icon-caret-top"></i>
					</div>
					<span class="action-text">{{ $t('top') }}</span>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	export default {
		name: 'RightFixedPanel',
		props: {
			showComplaint: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isLogin: false,
				user: {
					name: '',
					avatar: ''
				},
				appIcon: '/icon/common/app.png',
				discordIcon: '/icon/common/discord.png',
				forwardIcon: '/icon/common/forward.png',
				enquiryIcon: '/icon/common/enquiry.png',
				complaintIcon: '/icon/common/complaint.png',
			}
		},
		created() {
			this.checkLoginStatus()
			// 监听路由变化，在每次路由切换时检查登录状态
			this.$router.beforeEach((to, from, next) => {
				this.checkLoginStatus()
				next()
			})
		},
		watch: {
			// 监听登录状态变化
			isLogin: {
				handler(newVal) {
					// 当登录状态发生变化时，可以在这里执行相应的操作
					//console.log('登录状态变化:', newVal)
				},
				immediate: true
			}
		},
		methods: {
			handleAction(action) {
				this.$emit('action', action)
				switch (action) {
					case 'discord':
						this.$message.info('Join our Discord community!')
						break
					case 'relay':
						const currentUrl = window.location.href
						navigator.clipboard.writeText(currentUrl).then(() => {
							this.$message.success(this.$t('linkCopied'))
						}).catch(() => {
							this.$message.error('Failed to copy link')
						})
						break
					case 'complaint':
						this.$message.info('File a complaint!')
						break
				}
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
			handleEnquiry() {
				if (!this.isLogin) {
					this.handleLogin();
				} else {
					this.$emit('openEnquiry')
				}

			},
			handleComplaint() {
				if (!this.isLogin) {
					this.handleLogin();
				} else {
					this.$emit('openComplaint')
				}

			},
			handleLogin() {
				this.$confirm(this.$t('loginMessage'), this.$t('tip'), {
					confirmButtonText: this.$t('gotoLogin'),
					cancelButtonText: this.$t('closeLogin'),
					type: 'warning'
				}).then(() => {
					this.$router.push('/login')
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			checkLoginStatus() {
				// 与Login.vue中的存储逻辑保持一致
				const userInfo = storage.getUserInfo();
				const token = storage.getToken();
				const refreshToken = storage.getRefreshToken();
				if (userInfo && token) {
					this.isLogin = true
					this.user = JSON.parse(userInfo)
				} else {
					this.isLogin = false
				}
			}
		},
	}
</script>

<style scoped>
	.right-fixed-panel {
		position: fixed;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		z-index: 99;
	}

	.fixed-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
	}

	.action-buttons {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: white;
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		width: 60px;
	}

	.app-container {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.app-container:hover .action-item.app-item {
		background-color: #0171F9;
	}

	.app-container:hover .action-item.app-item .action-icon {
		color: #fff;
	}

	.app-container:hover .action-item.app-item .action-text {
		color: #fff;
	}

	.discord-container {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.discord-container:hover .action-item.discord-item {
		background-color: #0171F9;
	}

	.discord-container:hover .action-item.discord-item .action-icon {
		color: #fff;
	}

	.discord-container:hover .action-item.discord-item .action-text {
		color: #fff;
	}

	.discord-tooltip {
		position: absolute;
		top: -10px;
		right: 60px;
		background: #0171F9;
		padding: 15px 25px;
		z-index: 10000;
		margin-top: 10px;
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.3s ease, visibility 0.3s ease;
		display: flex;
		flex-direction: column;
		gap: 30px;
		width: 400px;
	}

	.discord-container:hover .discord-tooltip {
		opacity: 1;
		visibility: visible;
	}

	.discord-tooltip-top {
		display: flex;
		justify-content: center;
		color: #fff;
		font-weight: bold;
		text-align: center;
		padding: 0 20px;
	}

	.discord-tooltip-bottom {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.discord-tooltip-qr {
		display: flex;
		flex-direction: column;
		gap: 6px;
		width: 100px;
	}

	.discord-tooltip-qr-image {
		width: 70px;
		height: 70px;
	}

	.discord-tooltip-qr-text {
		font-size: 14px;
		color: #ccc;
	}

	.discord-tooltip-buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.discord-tooltip-button {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 13px 20px;
		border: none;
		border-radius: 50px;
		cursor: pointer;
		transition: all 0.3s ease;
		text-align: left;
		margin-left: 10px;
	}

	.discord-tooltip-button:hover {
		background-color: #0171F9;
	}

	.discord-tooltip-button.app-store {
		background-color: rgba(0, 0, 0, 0.2);
		color: #fff;
	}

	.discord-tooltip-button.app-store:hover {
		background-color: #000;
	}

	.discord-tooltip-button img {
		width: 25px;
	}

	.discord-tooltip-btn-text {
		display: flex;
		flex-direction: column;
	}

	.discord-download-text {
		font-size: 16px;
		font-weight: 600;
	}

	.action-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 60px;
		padding: 12px 0;
		cursor: pointer;
		transition: all 0.3s ease;
		border-bottom: 1px solid #f0f0f0;
		position: relative;
	}

	.action-item:last-child {
		border-bottom: none;
	}

	.action-item:hover {
		background-color: #0171F9;
	}

	.action-item:hover .action-icon {
		color: #fff;
	}

	.action-item:hover .action-text {
		color: #fff;
	}

	.action-icon {
		font-size: 24px;
		color: #666;
		margin-bottom: 4px;
		transition: color 0.3s ease;
	}

	.action-icon img {
		width: 30px;
		height: 30px;
	}

	.action-text {
		font-size: 12px;
		color: #333;
		text-align: center;
		transition: color 0.3s ease;
	}

	.app-container {
		position: relative;
	}

	.app-tooltip {
		position: absolute;
		top: 165.5px;
		right: 60px;
		transform: translateY(-50%);
		background: #0171F9;
		padding: 25px;
		display: flex;
		flex-direction: column;
		gap: 12px;
		z-index: 10000;
		white-space: nowrap;
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.3s ease, visibility 0.3s ease;
	}

	.app-container:hover .app-tooltip {
		opacity: 1;
		visibility: visible;
	}

	.tooltip-qr {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;
	}

	.tooltip-qr-image {
		width: 120px;
		height: 120px;
	}

	.tooltip-qr-text {
		font-size: 14px;
		color: #ccc;
	}

	.tooltip-buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.tooltip-button {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 13px 20px;
		border: none;
		border-radius: 50px;
		cursor: pointer;
		transition: all 0.3s ease;
		text-align: left;
	}

	.tooltip-button:hover {
		background-color: #0171F9;
	}

	.tooltip-button.app-store {
		background-color: rgba(0, 0, 0, 0.2);
		color: #fff;
	}

	.tooltip-button.app-store:hover {
		background-color: #000;
	}

	.tooltip-button.google-play {
		background-color: rgba(0, 0, 0, 0.2);
		color: #fff;
	}

	.tooltip-button.google-play:hover {
		background-color: #000;
	}

	.tooltip-button img {
		width: 25px;
	}

	.tooltip-btn-text {
		display: flex;
		flex-direction: column;
	}

	.download-text {
		font-size: 16px;
		font-weight: 600;
	}

	.dialog-footer {
		display: flex;
		justify-content: center;
		gap: 20px;
	}

	.dialog-footer .el-button {
		padding: 10px 30px;
		border-radius: 4px;
	}

	.dialog-footer .el-button--primary {
		background-color: #0171F9;
		border-color: #0171F9;
	}

	.dialog-footer .el-button--primary:hover {
		background-color: #0158d4;
		border-color: #0158d4;
	}

	.enquiry-dialog {
		border-radius: 8px;
	}

	.enquiry-form {
		padding: 10px 20px;
	}

	.image-uploader {
		width: 178px;
		height: 178px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.image-uploader:hover {
		border-color: #409EFF;
	}

	.image-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.uploaded-image {
		width: 178px;
		height: 178px;
		display: block;
		cursor: pointer;
	}
</style>